import React from 'react';
import { Col, Row, Container } from "react-bootstrap"
import '../../styles/home.scss'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

const HeroSection = () => {
    return (
      <section id="hero-section">
        <Container>
          <Row className=" justify-content-center">
            <Col md={10} className="text-center">
              <h1>
                Win Over Addiction. Transform Your Life. Find Addiction Rehab
                Today!
              </h1>
            </Col>
            <div className="form-group has-search mt-5">
              <input
                type="text"
                className="form-control"
                placeholder="How Can We Help You?"
              />
              {/* <span className="search-icon">
                <FontAwesomeIcon icon={faSearch} />
              </span> */}
            </div>
          </Row>
        </Container>
      </section>
    )
}
 
export default HeroSection;